<template>
  <div class="child-canvas" :id="mainCanvasId">
    <canvas :id="canvasId" :width="canvasWidth" :height="canvasHeight" style="border:0px solid #d3d3d3;overflow: auto;">Your browser does not support the HTML5 canvas tag.</canvas>
    <Imgx v-if="isActive" style="display: none;"></Imgx>
  </div>
</template>
<script>
import Imgx from './img.vue';
import { Loading } from 'element-ui';
import T from '@/utils/tools.js';
import API from '@/api/svolt/wiring-diagram';
const { json } = require('./jsontest.js');
export default {
  name: 'main-canvas',
  components: { Imgx },
  props: {
    mainCanvasId: {
      type: String,
      default: 'mainCanvas'
    },
    itemData: {
      type: [Array, Object]
    },
    //画布ID
    canvasId: {
      type: String,
      default: 'myCanvas'
    },
    //画布宽度
    canvasWidth: {
      type: Number,
      default: 2500
    },
    //画布高度
    canvasHeight: {
      type: Number,
      default: 700
    },
    //起始点y轴
    originY: {
      type: Number,
      default: 0
    },
    //起始点y轴
    originX: {
      type: Number,
      default: 0
    },
    //行间距
    lineHeight: {
      type: Number,
      default: 24
    },
    //字号大小
    fontSize: {
      type: Number,
      default: 12
    },
    //设置字体
    fontFamily: {
      type: String,
      default: 'SimHei'
    },
    //间隔空间
    space: {
      type: Number,
      default: 6
    },
    //右间距
    rightSpace: {
      type: Number,
      default: 24
    },
    //项目ID
    projectId: {
      type: String,
      default: '86-030000-001'
    },
    //tabID
    tabId: {
      type: [Number, String]
    },
    //文字基本位置
    textBaseline: {
      type: String,
      default: 'top'
    },
    //标题默认的颜色
    titleColor: {
      type: String,
      default: '#FFFFFF'
    }
  },
  data: function() {
    return {
      //元素对象
      documentObj: '',
      //画布对象
      canvasObj: '',
      //是否激活
      isActive: true,
      //加载图选项
      options: {
        lock: true,
        text: '正在加载',
        spinner: 'el-icon-loading lodings',
        background: 'rgba(0, 0, 0, 0.7)'
      },
      //记录点位
      rememberPoint: {},
      //所有反节点
      allNode: [],
      //头部长度
      headLength: 380,
      //头部颜色
      headColor: '#FFB202',
      //定时记录
      interval: '',
      //记录按钮锚点
      btnClickArray: [],
      loadingInstance: ''
    };
  },
  methods: {
    //初始化
    init() {
      this.$nextTick(function() {
        this.documentObj = document.getElementById(this.canvasId);
        this.canvasObj = this.documentObj.getContext('2d');
        const dpr = window.devicePixelRatio;
        const logicalWidth = this.canvasWidth;
        const logicalHeight = this.canvasHeight;
        this.documentObj.width = logicalWidth * dpr;
        this.documentObj.height = logicalHeight * dpr;
        this.documentObj.style.width = logicalWidth + 'px';
        this.documentObj.style.height = logicalHeight + 'px';
        this.canvasObj.scale(dpr, dpr);
        this.clearCanvas(this.documentObj.width, this.documentObj.height);
        let leafData = T.getAllLeaf(this.allNode);
        let layerData = T.getAllNode(this.allNode);
        let elementData = [];
        let length = 0;
        let tmp = {};
        layerData.forEach((item, index) => {
          //?
          if (tmp.x) {
            length = tmp.x;
            if (tmp.level != item.level) {
              //获取设备宽度
              length = T.getTotalLength(item);
            }
          }
          //设置高度
          tmp = T.getParentNodeInfo(layerData, item, length);
          elementData.push(tmp);
        });
        //定位叶子节点x轴
        elementData.map(item => {
          leafData.forEach(childItem => {
            if (childItem.id == item.id) {
              item.x = childItem.x;
            }
          });
        });
        //分组
        let temp = T.getArrayGroup(elementData, 'level');
        let point = {};
        temp = temp.map((item, idx) => {
          for (let i = 0; i < item.length; i++) {
            if (item[i].x) {
              //叶子节点
            } else {
              if (item[i].children.length == 1) {
                item[i].x = item[i].children[0].x;
              } else {
                let childLen = item[i].children.length;
                let one = item[i].children[0];
                let end = item[i].children[childLen - 1];
                item[i].x = end.x - (end.x - one.x) / 2;
              }
            }
            point = this.setDevice(item[i]);
          }
          return item;
        });
        //封顶
        // this.setLine({ x: point.x - this.headLength / 2, y: 0, linetype: 1, linecolor: this.headColor, linelength: this.headLength, direction: 'row' });
        // this.closeLoading(this.loadingInstance)
        this.$emit('complete');
      });
    },
    //关闭加载条
    closeLoading(loadingInstance) {
      this.$nextTick(() => {
        // loadingInstance.close();
      });
    },
    //写设备
    setDevice(item, point) {
      let x = 0;
      let y = 0;
      if (!point) {
        x = item.x;
        y = item.y;
      } else {
        x = point.x;
        y = point.y;
      }
      //上线数据
      if (item.lineUp && item.lineUp.linetype > 0) {
        let lineUp = item.lineUp;
        let linelength = lineUp.linelength;
        lineUp.x = x;
        lineUp.y = y;
        this.setLine(lineUp);
        y = y + parseInt(linelength);
      }
      //图片
      let imgParams = {};
      if (item.image) {
        let width = 0;
        let height = 0;
        let sizes = item.imageSizes;
        let offsetX = 0;
        if (sizes) {
          sizes = sizes.split(',');
          width = parseInt(sizes[0]);
          height = parseInt(sizes[1]);
        }
        if (item.type == '219') {
          offsetX = 6;
        }
        imgParams = { id: item.image, width: width, height: height, x: x + offsetX, y: y };
        // this.setText({ x:  x + offsetX+30, y: y+10, text: item.name+item.children.length+item.id, color: '#ffffff' });
        this.setImg(imgParams);
        y = y + height;
      }
      //新增设备302
      if (item.nameType == 302) {
        let width = 0;
        let height = 0;
        let sizes = item.imageSizes;
        if (sizes) {
          sizes = sizes.split(',');
          width = parseInt(sizes[0]);
          height = parseInt(sizes[1]);
        }
        let text = item.name;
        let len = T.getTextWidth(text, this.canvasObj);
        this.setText({ x: x-len-width, y: y - height/2-10, fontSize: 20, text: item.name, color: '#ffffff' });
      }
      //新增电表名称
      if (item.nameType == 259) {
        //写设备下1:设备下，2:下线下
        let text = item.name;
        let len = T.getTextWidth(text, this.canvasObj);
        this.setText({ x: 20, y: 20, fontSize: 20, text: item.name, color: '#ffffff' });
      }
      //写跳转按钮
      if (item.button && item.button.type == 1) {
        if (item.button.id == '11') {
        }
        this.getBtn({
          id: item.button.id,
          url: item.button.url,
          text: item.button.name,
          width: item.button.width,
          height: 30,
          x: x - item.button.width / 2,
          y: y + item.button.moveDown,
          color: '#389bc7'
        });
      }
      //下线数据
      if (item.lineDown && item.lineDown.linetype > 0) {
        let lineDown = item.lineDown;
        lineDown.x = x;
        lineDown.y = y;
        this.setLine(lineDown);
        y = y + parseInt(lineDown.linelength);
      }
      //设备名称258
      if (item.nameType == 258) {
        //写设备下1:设备下，2:下线下
        y = y + this.fontSize;
        let text = item.name;
        let len = T.getTextWidth(text, this.canvasObj);
        this.setText({ x: x - len / 2, y: y, text: item.name, color: '#79D8FF' });
      }
      //下横线
      if (item.children && item.children.length > 1) {
        let num = item.children.length;
        let len = item.children[num - 1].x;
        //获取设备下的第一个坐标
        let endX = item.children[0].x;
        let endY = item.children[0].y;
        let endColor = item.lineDown.linecolor;
        let endLen = len - endX;
        this.setLine({ x: endX, y: endY, linetype: 1, linelength: endLen, linecolor: endColor, direction: 'row' });
      }

      //写vo名称
      if (item.includeVo && item.includeVo.name) {
        let sizes = item.groupSizes.split(',');
        let groupWidth = parseInt(sizes[0]);
        let groupHeight = parseInt(sizes[1]);
        let btnWidth = 70;
        let btnHeight = 26;
        let fontSize = 16;
        let vox = x - (groupWidth / 2 - btnWidth) - 62;
        let voy = y - (groupHeight + this.lineHeight) - 6;
        this.setStack({ x: vox, y: voy, text: item.includeVo.name, width: btnWidth, height: btnHeight, fontSize: fontSize });
      }

      /* 写属性 */
      //属性集合
      let fields = item.fields;
      //组的宽高
      let sizes = item.groupSizes.split(',');
      //组的高度
      let groupheight = T.getDeviceHeight(item);
      //左侧层级
      let leftLayer = 0;
      //右侧层级
      let rightLayer = 0;
      //下侧层级
      let bottomLayer = 0;
      //分解属性
      if (fields.length > 0) {
        fields.forEach((data, index) => {
          let info = {};
          info.x = x;
          info.y = y;
          if (data[0].position == 'left') {
            info.layer = leftLayer++;
          }
          if (data[0].position == 'right') {
            info.layer = rightLayer++;
          }
          if (data[0].position == 'down') {
            info.layer = bottomLayer++;
          }
          info.data = data;
          info.groupwidth = parseInt(sizes[0]);
          info.groupheight = parseInt(sizes[1]) + imgParams.height;
          info.imagewidth = imgParams.width;
          info.imageheight = imgParams.height;
          this.setAttr(info);
        });
      }
      return { x: x, y: y };
    },
    //写属性,所有属性兼容,在item里带入x，y坐标，index层级
    setAttr(info) {
      //是摇信数据
      if (info.data.length) {
        info.data.forEach((item, index) => {
          item.x = info.x;
          item.y = info.y;
          item.layer = info.layer;
          item.groupwidth = info.groupwidth;
          item.groupheight = info.groupheight;
          item.index = index;
          item.imagewidth = info.imagewidth;
          item.imageheight = info.imageheight;
          //调整设备属性显示位置+偏移量
          let offsetHeight = 40;
          item.y = item.y - item.groupheight + offsetHeight;
          switch (item.dataType) {
            case 1: {
              //数据-遥测
              this.setDataAttr(item);
              break;
            }
            case 2: {
              //状态-摇信
              this.setStatusAttr(item);
              break;
            }
          }
        });
      }
    },
    //写数据信息()
    setDataAttr(item) {
      //中心点x
      let centerx = item.x;
      //中心点y
      let centery = item.y;
      //位置
      let position = item.position;
      //设备组宽度
      let groupwidth = item.groupwidth;
      //设备组的高度
      let groupheight = item.groupheight;
      //图片的宽度
      let imagewidth = item.imagewidth;
      //图片的高度
      // let imageheight = item.imageheight;
      //层级
      let layer = item.layer;
      //索引
      let index = item.index;
      //起点x
      let startx = 0;
      //起点y
      let starty = 0;
      if (position == 'left') {
        //左侧属性定位
        startx = centerx - groupwidth / 2;
        starty = centery + layer * this.lineHeight;
      } else if (position == 'right') {
        //右侧属性定位
        startx = centerx + imagewidth / 2 + this.rightSpace;
        let offsetHeight = 0;
        starty = centery + layer * this.lineHeight + offsetHeight;
      } else if (position == 'down') {
        startx = centerx;
        let offsetHeight = 0;
        starty = centery + layer * this.lineHeight + offsetHeight;
      }
      if (item.name == '堆SOC') {
        console.log(item.name + starty + '样式' + item.style);
      }
      switch (item.style) {
        //类型1，有icon,有名成，有多个数值
        case 269: {
          //如果图片image则写图片
          let point = {};
          if (item.image) {
            //当前图片的宽高
            let sizes = item.imageSizes.split(',');
            let width = parseInt(sizes[0]);
            let height = parseInt(sizes[1]);
            let offsetH = 0; //偏移量20
            let params = { id: item.image, x: startx, y: starty + offsetH, width: width, height: height };
            point = this.setImg(params);
          }
          //如果有名称name则写名称
          if (index == 0) {
            //颜色
            let color = this.titleColor;
            //高的偏移量
            let offsetHeight = 6;
            point = this.setText({ color: color, text: item.name, x: point.x + this.space, y: point.y + offsetHeight });
          }
          //写属性值
          let color = item.color;
          let text = item.value + item.unit;
          let x = 0;
          let y = 0;
          if (index == 0) {
            x = point.x + this.space;
            y = point.y;
          } else {
            x = this.rememberPoint.x + this.space;
            y = this.rememberPoint.y;
          }
          this.rememberPoint = this.setText({ color: color, text: text, x: x, y: y }, index);
          // this.setText({ color: color, text: item.id, x: x, y: y+10 }, index);
          break;
        }
        //有icon有属行，名称和数值折行
        case 271: {
          //如果图片image则写图片
          let point = {};
          if (item.image) {
            //当前图片的宽高
            if (item.imageSizes.indexOf(',') == -1) {
              this.$message.error('图片宽高错误:' + item.imageSizes + 'src:' + item.image);
              return false;
            }
            let sizes = item.imageSizes.split(',');
            let width = parseInt(sizes[0]);
            let height = parseInt(sizes[1]);
            let params = { id: item.image, x: startx, y: starty, width: width, height: height };
            // this.setText({ color: this.titleColor, text: item.id+'('+starty+')', x: startx, y: starty+30 });
            point = this.setImg(params);
          }
          //写数据
          let color = item.color;
          let text = item.value + item.unit;
          let x = 0;
          let y = 0;
          x = point.x + this.space;
          y = point.y;
          this.setText({ color: color, text: text, x: x, y: y });

          //写名称
          text = item.name;
          y = y + this.fontSize;
          this.setText({ color: this.titleColor, text: text, x: x, y: y });

          break;
        }
        //电池簇的左右类型4
        case 272: {
          let offsetHeight = 0;
          //写标题
          if (item.nameType == 261) {
            this.setText({ color: this.titleColor, text: item.name, x: centerx - 30, y: starty + offsetHeight, align: 'right' });
          }
          this.setText({ x: startx - 10, y: starty + offsetHeight, text: item.value + item.unit, color: item.color });
          break;
        }
        //电池簇属性类型5
        case 273: {
          let offsetHeight = groupheight;
          //写数值
          if (item.position == 'down') {
            this.setText({ color: item.color, text: item.value, x: centerx, y: starty + offsetHeight, align: 'center' });
          }
          //写标题
          if (item.nameType == 261) {
            this.setText({ color: this.titleColor, text: item.name, x: centerx - 30, y: starty + offsetHeight, align: 'right' });
          }
          break;
        }
        //新增变压器右侧属性
        case 294: {
          //写数值
          if (item.position == 'right') {
            this.setText({ color: item.color, text: item.name, x: centerx + 80, y: 20, align: 'center' });
          }
          break;
        }
        //新增电表右侧三项数据名称
        case 295: {
          //如果图片image则写图片
          let point = {};
          //如果有名称name则写名称
          if (index == 0) {
            //颜色
            let color = this.titleColor;
            //高的偏移量
            let offsetHeight = 6;
            let tmpY = point.y ? point.y : starty;
            let tmpX = point.x ? point.x : startx;
            point = this.setText({ color: color, text: 'NO.' + item.name, x: tmpX + 17, y: tmpY + offsetHeight });
          }
          break;
        }
        //新增电表右侧三项数据
        case 296: {
          //如果图片image则写图片
          let point = {};
          if (item.image) {
            //当前图片的宽高
            let sizes = item.imageSizes.split(',');
            let width = parseInt(sizes[0]);
            let height = parseInt(sizes[1]);
            let offsetH = 0; //偏移量20
            let params = { id: item.image, x: startx, y: starty + offsetH, width: width, height: height };
            point = this.setImg(params);
          }
          //如果有名称name则写名称
          if (index == 0) {
            //颜色
            let color = this.titleColor;
            //高的偏移量
            let offsetHeight = 6;
            let tmpY = point.y ? point.y : starty;
            let tmpX = point.x ? point.x : startx;
            point = this.setText({ color: color, text: item.name, x: tmpX + this.space, y: tmpY + offsetHeight });
          }
          //写属性值
          let color = item.color;
          let text = item.value + item.unit;
          let x = 0;
          let y = 0;
          if (index == 0) {
            x = point.x + this.space;
            y = point.y;
          } else {
            x = this.rememberPoint.x + this.space;
            y = this.rememberPoint.y;
          }
          if (text != undefined) {
            // console.log(index, text, item.name, '****');
            if (item.name.indexOf('TR') == -1) {
              this.rememberPoint = this.setText({ color: color, text: text, x: x, y: y }, index);
            }
          }
          break;
        }
        //新增电表标题新属性
        case 297: {
          //写数值
          if (item.position == 'right') {
            this.setText({ color: item.color, text: 'NO.' + item.name, x: startx + 50, y: starty + 30, align: 'right' });
          }
          break;
        }
        //新增电表右侧标题
        case 298: {
          //如果图片image则写图片
          let point = {};
          if (item.image) {
            //当前图片的宽高
            let sizes = item.imageSizes.split(',');
            let width = parseInt(sizes[0]);
            let height = parseInt(sizes[1]);
            let offsetH = 0; //偏移量20
            let params = { id: item.image, x: startx, y: starty + offsetH, width: width, height: height };
            point = this.setImg(params);
          }
          //如果有名称name则写名称
          if (index == 0) {
            //颜色
            let color = this.titleColor;
            //高的偏移量
            let offsetHeight = 6;
            let tmpY = point.y ? point.y : starty + 20;
            let tmpX = point.x ? point.x : startx;
            if (item.nameType == 261) {
              point = this.setText({ color: color, text: item.name, align: 'right', x: tmpX - 100, y: tmpY + offsetHeight });
            }
          }
          //写属性值
          let color = item.color;
          let text = item.value + item.unit;
          let x = 0;
          let y = 0;
          let marginleft = 10;
          let margintop = 0;
          if (index == 0) {
            x = point.x ? point.x : startx;
            y = point.y ? point.y : starty;
          } else {
            x = this.rememberPoint.x;
            y = this.rememberPoint.y;
          }
          if (index == 0) {
            if (item.nameType == 261) {
              //列的第一条记录
              marginleft = 37;
              if (item.name == '功率因数') {
                marginleft = 49;
              }
            } else {
              //列的第二条记录
              marginleft = -4;
              margintop = 27;
            }
          } else {
            marginleft = 10;
          }
          this.rememberPoint = this.setText({ color: color, text: text, align: 'left', x: x + marginleft, y: y + margintop }, index);
          break;
        }
      }
    },
    //写状态信息
    setStatusAttr(item) {
      //中心点x
      let centerx = item.x;
      //中心点y
      let centery = item.y;
      //位置
      let position = item.position;
      //设备组宽度
      let groupwidth = item.groupwidth;
      //设备组的高度
      // let groupheight = item.groupheight;
      //图片的宽度
      let imagewidth = item.imagewidth;
      //图片的高度
      // let imageheight = item.imageheight;
      //层级
      let layer = item.layer;
      //索引
      // let index = item.index;
      //起点x
      let startx = 0;
      //起点y
      let starty = 0;
      if (position == 'left') {
        //左侧属性定位
        startx = centerx - groupwidth / 2;
        starty = centery + layer * this.lineHeight;
      } else if (position == 'right') {
        //右侧属性定位
        startx = centerx + imagewidth / 2 + this.rightSpace;
        let offsetHeight = 6;
        if (this.rememberPoint.index) {
          layer = layer - (this.rememberPoint.index + 1);
        }
        starty = centery + layer * this.lineHeight + offsetHeight;
      }
      if (item.name == '堆告警状态') {
        console.log(item.name + starty);
      }
      switch (item.style) {
        //类型2，有状态,有描述
        case 270: {
          //如果有名称name则写名称
          //颜色
          let color = this.titleColor;
          //高的偏移量
          let offsetHeight = 6;
          //点
          let point = {};
          point = this.setText({ color: color, text: item.name, x: startx + this.space, y: starty + offsetHeight });

          //写属圆点
          let x = point.x;
          let y = point.y;
          let r = 6;
          let offset = { x: 12, y: 6 };
          color = item.color;
          point = this.getArc({ x: x, y: y, r: r, color: color, offset: offset });

          //写描述
          let text = item.desc;
          x = point.x;
          y = point.y;
          this.setText({ color: color, text: text, x: x, y: y });
          break;
        }
        //电池簇的左右类型4
        case 272: {
          let offsetHeight = 0;
          //写标题
          if (item.nameType == 261) {
            this.setText({ color: this.titleColor, text: item.name, x: centerx - 30, y: starty + offsetHeight, align: 'right' });
          }
          this.getBtn({ x: startx - 10, y: starty + offsetHeight, text: item.desc, color: item.color });
          break;
        }
        case 299: {
          //如果有名称name则写名称
          //颜色
          let color = this.titleColor;
          //高的偏移量
          let offsetHeight = 14*item.layer;
          //点
          let point = {};
          if (item.nameType == 261) {
            point = this.setText({ color: color, text: item.name, align: 'right', x: startx - 100, y: starty + offsetHeight });
          }
          //写属圆点
          let x = point.x?point.x:startx;
          let y = point.y?point.y:starty;
          let r = 6;
          let offset = { x: 52, y: 6 };
          if(item.nameType==261){
            color = item.color;
            point = this.getArc({ x: x, y: y, r: r, color: color, offset: offset });
            //写描述
            let text = item.desc;
            x = point.x;
            y = point.y;
            this.setText({ color: color, text: text, x: x, y: y });
          }else{
            color = item.color;
            x = x-50;
            y = y+offsetHeight;
            point = this.getArc({ x: x, y: y, r: r, color: color, offset: offset });

            //写描述
            let text = item.desc;
            x = point.x;
            y = point.y;
            this.setText({ color: color, text: text, x: x, y: y });
          }

          break;
        }
      }
    },
    //获取堆按钮
    setStack(item) {
      let width = item.width;
      let height = item.height;
      let lineWidth = 1;
      // let fillcolor = '#1b1c39';
      let fillcolor = '#10204a';
      let strokecolor = '#FA6400';
      this.canvasObj.fillStyle = fillcolor;
      this.canvasObj.strokeStyle = '#FA6400';
      this.canvasObj.fillRect(item.x, item.y, width, height);
      this.canvasObj.lineWidth = lineWidth;
      this.canvasObj.strokeRect(item.x, item.y, width, height);
      let offsetWidth = Math.abs((width - item.text.length * 9) / 2); //数据居中
      this.setText({ color: strokecolor, text: item.text, x: item.x + offsetWidth, y: item.y + 5, fontSize: item.fontSize });
    },
    //获取固定圆
    getArc(point) {
      this.canvasObj.beginPath();
      let x = point.x;
      let y = point.y;
      let r = point.r;
      let PI = 2 * Math.PI;
      if (point.offset) {
        x = point.x + point.offset.x;
        y = point.y + point.offset.y;
      }
      this.canvasObj.arc(x, y, r, 0, PI);
      this.canvasObj.fillStyle = point.color;
      this.canvasObj.closePath();
      this.canvasObj.fill();
      return { x: x + point.r * 2, y: point.y };
    },
    //获取固定的三角
    setTriangle(item) {
      item = JSON.parse(JSON.stringify(item));
      let x = 1;
      let y = 6;
      let z = 12;
      let type = 'triangle';
      item.x -= 6;
      let color = item.color;
      let data = [
        {
          //正三角
          type: type,
          color: color,
          X: { x: item.x + y, y: item.y + x },
          Y: { x: item.x + x, y: item.y + y },
          Z: { x: item.x + z, y: item.y + y }
        },
        {
          //反三角
          type: type,
          color: color,
          X: { x: item.x + x, y: item.y + x },
          Y: { x: item.x + z, y: item.y + x },
          Z: { x: item.x + y, y: item.y + y }
        }
      ];
      this.canvasObj.fillStyle = data[item.index].color;
      this.canvasObj.beginPath();
      this.canvasObj.moveTo(data[item.index].X.x, data[item.index].X.y);
      this.canvasObj.lineTo(data[item.index].Y.x, data[item.index].Y.y);
      this.canvasObj.lineTo(data[item.index].Z.x, data[item.index].Z.y);
      this.canvasObj.closePath();
      this.canvasObj.fill();
    },
    /*
            linetype": 1, 0-没有 1-普通线，2-开关，3-块开关
            "linestatus": 0,0-闭合，1-开启
            "arrow":0,1-上，2-下 ,默认-0
            "linelength": 123,
            "linecolor": "#FC2341" //颜色
        */
    //绘制线路
    setLine(item) {
      this.canvasObj = this.documentObj.getContext('2d');
      this.canvasObj.lineWidth = 2;
      this.canvasObj.strokeStyle = item.linecolor;
      this.canvasObj.fillStyle = item.linecolor;
      switch (item.linetype) {
        case 1: {
          //普通线
          this.canvasObj.beginPath();
          this.canvasObj.moveTo(item.x, item.y);
          if (item.direction && item.direction == 'row') {
            this.canvasObj.lineTo(item.x + item.linelength, item.y);
          } else {
            this.canvasObj.lineTo(item.x, item.y + item.linelength);
          }
          this.canvasObj.stroke();
          //定位流向
          if (item.arrow != '') {
            item.arrow = parseInt(item.arrow);
          }
          if (item.arrow > 0) {
            let x = item.x;
            let offsetHeight = 6;
            if (item.arrow == 2) {
              offsetHeight = 0;
            }
            let y = item.y + item.linelength / 2 - offsetHeight;
            let color = item.linecolor;
            let index = item.arrow - 1;
            let params = {
              x: x,
              y: y,
              color: color,
              index: index
            };
            this.setTriangle(params);
          }
          break;
        }
        case 2: {
          //开关
          this.setSwitch(item);
          break;
        }
        case 3: {
          //块开关
          this.setSwitch(item);
          break;
        }
        default: {
          //没有线
          break;
        }
      }
    },
    //设置开关0:闭，1:开
    setSwitch(item) {
      //半径
      let r = 1;
      //x 坐标
      let x = item.x;
      //y 坐标
      let y = item.y;
      //开关斜深度
      let h = 16;
      //关闭的原点
      let closeX = 3;
      //开合的原点
      let openX = 7;
      //x轴偏移量
      let offsetX = 1;
      //块的宽度
      let blockWidth = 11;
      //块的高度
      let blockHeight = 20;

      //上线高度（开关的高度的一半）
      let size = (item.linelength - h) / 2;
      if (item.linetype == 2) {
        this.canvasObj.beginPath();
        this.canvasObj.moveTo(x, y);
        y = y + size;
        this.canvasObj.lineTo(x, y);
        this.canvasObj.stroke();
      } else if (item.linetype == 3) {
        size = (item.linelength - h - blockHeight) / 4;
        this.canvasObj.beginPath();
        this.canvasObj.moveTo(x, y);
        let oneSize = size * 2;
        y = y + oneSize;
        this.canvasObj.lineTo(x, y);
        this.canvasObj.stroke();
        //配置方块
        this.setRect({ x: x, y: y, color: item.linecolor, width: blockWidth, height: blockHeight });
        y = y + blockHeight;
        this.canvasObj.beginPath();
        this.canvasObj.moveTo(x, y);
        y = y + size;
        this.canvasObj.lineTo(x, y);
        this.canvasObj.stroke();
      }

      //原点
      this.getArc({ x: x + offsetX, y: y, r: r, color: item.linecolor });
      //斜线
      if (item.linestatus == '0') {
        this.canvasObj.moveTo(x + closeX, y);
        y = y + h;
        this.canvasObj.lineTo(x, y);
      } else {
        this.canvasObj.moveTo(x + openX, y);
        y = y + h;
        this.canvasObj.lineTo(x, y);
      }
      this.canvasObj.stroke();
      //移动到
      this.canvasObj.moveTo(x, y);
      this.canvasObj.lineTo(item.x, y + size);
      this.canvasObj.stroke();
      this.canvasObj.closePath();
    },
    //绘制图片
    setImg(item) {
      var img = document.getElementById(item.id);
      let x = item.x - item.width / 2;
      if (img == null) {
        this.$message.error('图片异常请查看数据：' + JSON.stringify(item));
        return;
      }
      this.canvasObj.drawImage(img, x, item.y, item.width, item.height);
      return { x: x + item.width, y: item.y };
    },
    //绘制文本
    setText(item, index) {
      let fs = item.fontSize == undefined ? this.fontSize : item.fontSize;
      this.canvasObj.font = fs + 'px ' + this.fontFamily;
      this.canvasObj.textBaseline = this.textBaseline;
      if (item.align) {
        this.canvasObj.textAlign = item.align;
      } else {
        this.canvasObj.textAlign = 'left';
      }
      if (item.color) {
        this.canvasObj.fillStyle = item.color;
      } else {
        this.canvasObj.fillStyle = this.color;
      }
      this.canvasObj.fillText(item.text, item.x, item.y);
      let width = T.getTextWidth(item.text, this.canvasObj);
      let result = { x: item.x + width, y: item.y };
      if (index) {
        result.index = index;
      }
      return result;
    },
    //绘制方块
    setRect(item) {
      this.canvasObj.fillStyle = item.color;
      this.canvasObj.fillRect(item.x - item.width / 2, item.y, item.width, item.height);
    },
    //清除画布
    clearCanvas(width, height) {
      this.canvasObj.clearRect(0, 0, width, height);
    },
    //获取按钮
    getBtn(item) {
      let width = item.width || 39;
      let height = item.height || 17;
      let offsetY = 2;
      // this.canvasObj.fillStyle = item.color;
      // this.canvasObj.fillRect(item.x, item.y, width, height);
      // this.fillRoundRect(item.x, item.y, width, height, 5, item.color);
      if (!item.id) {
        this.fillRoundRect(item.x, item.y, width, height, 5, item.color);

        if (item.height) {
          offsetY = 8;
        }
        // this.setText({ color: this.titleColor, text: item.text, x: item.x + 7, y: item.y + offsetY });
        this.setText({ color: this.titleColor, text: item.text, x: item.x + 7, y: item.y + offsetY });
      }

      //记录锚点点击
      if (item.id) {
        let has = 0;
        this.btnClickArray.forEach(btnitem => {
          if (btnitem.id == item.id) {
            has = 1;
          }
        });
        if (!has) {
          this.btnClickArray.push({ id: item.id, x: item.x, y: item.y, width: width, height: height });
          this.createBtn(item);
        }
      }
    },
    //清空按钮
    clearBtn(x, y, width, height) {
      this.fillRoundRect(x, y, width, height, 0, '#000');
    },
    fillRoundRect(x, y, width, height, radius, fillColor) {
      //圆的直径必然要小于矩形的宽高
      if (2 * radius > width || 2 * radius > height) {
        return false;
      }

      this.canvasObj.save();
      this.canvasObj.translate(x, y);
      //绘制圆角矩形的各个边
      this.drawRoundRectPath(width, height, radius);
      this.canvasObj.fillStyle = fillColor || '#000'; //若是给定了值就用给定的值否则给予默认值
      this.canvasObj.fill();
      this.canvasObj.restore();
    },
    strokeRoundRect(x, y, width, height, radius, /*optional*/ lineWidth, /*optional*/ strokeColor) {
      //圆的直径必然要小于矩形的宽高
      if (2 * radius > width || 2 * radius > height) {
        return false;
      }
      this.canvasObj.save();
      this.canvasObj.translate(x, y);
      //绘制圆角矩形的各个边
      this.drawRoundRectPath(width, height, radius);
      this.canvasObjlineWidth = lineWidth || 2; //若是给定了值就用给定的值否则给予默认值2
      this.canvasObjstrokeStyle = strokeColor || '#000';
      this.canvasObj.stroke();
      this.canvasObj.restore();
    },
    drawRoundRectPath(width, height, radius) {
      this.canvasObj.beginPath(0);
      //从右下角顺时针绘制，弧度从0到1/2PI
      this.canvasObj.arc(width - radius, height - radius, radius, 0, Math.PI / 2);

      //矩形下边线
      this.canvasObj.lineTo(radius, height);

      //左下角圆弧，弧度从1/2PI到PI
      this.canvasObj.arc(radius, height - radius, radius, Math.PI / 2, Math.PI);

      //矩形左边线
      this.canvasObj.lineTo(0, radius);

      //左上角圆弧，弧度从PI到3/2PI
      this.canvasObj.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2);

      //上边线
      this.canvasObj.lineTo(width - radius, 0);

      //右上角圆弧
      this.canvasObj.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2);

      //右边线
      this.canvasObj.lineTo(width, height - radius);
      this.canvasObj.closePath();
    },
    //创建按钮绑定点击事件
    createBtn(point) {
      let self = this;
      var mainCanvas = document.getElementById(this.mainCanvasId);
      var btn = document.createElement('span');
      btn.id = 'btn' + point.id;
      btn.className = 'click-btn';
      btn.style.position = 'absolute';
      btn.style.left = point.x + 'px';
      btn.style.top = point.y + 'px';
      btn.style.width = point.width + 'px';
      btn.style.height = point.height + 'px';
      btn.style.background = '#389BC7';
      btn.style.borderRadius = '5px';
      btn.style.zIndex = '999';
      btn.style.opacity = 1;
      btn.style.lineHeight = '30px';
      btn.style.color = '#FFFFFF';
      btn.style.fontSize = '12px';
      btn.style.textAlign = 'center';
      btn.className = 'onpoint';
      btn.innerText = point.text;
      btn.onclick = function() {
        self.toUrl(point);
      };
      mainCanvas.appendChild(btn);
    },
    //重定向到指定地址
    toUrl(point) {
      this.$emit('toUrl', point);
    },
    //计算(AB X AE ) * (CD X CE)  >= 0 && (DA X DE ) * (BC X BE) >= 0
    GetCross(p1, p2, p) {
      return (p2.x - p1.x) * (p.y - p1.y) - (p.x - p1.x) * (p2.y - p1.y);
    },
    //判断点p是否在p1p2p3p4的正方形内
    IsPointInMatrix(p1, p2, p3, p4, p) {
      let isPointIn = this.GetCross(p1, p2, p) * this.GetCross(p3, p4, p) >= 0 && this.GetCross(p2, p3, p) * this.GetCross(p4, p1, p) >= 0;
      return isPointIn;
    },
    //获取动态数据
    getMainData() {
      // let data = testData.data;
      let self = this;
      // this.loadingInstance = Loading.service(self.options)
      let params = {
        projectId: this.projectId, // 暂时使用6个0代替还没有确定项目编号
        tabId: this.tabId
      };
      API.wiringDiagram(params)
        .then(res => {
          let realData = res.data.data;
          // let realData = json.data;
          if (realData && realData.length > 0) {
            self.allNode = T.getAllNode(realData);
            self.init();
          } else {
            self.$emit('complete');
          }
        })
        .catch(function(error) {
          self.$emit('complete');
        });
    },
    //冲加载
    reload() {
      if (this.itemData.length) {
        this.allNode = T.getAllNode(this.itemData);
        this.init();
      }
    },
    //重新刷新程序
    resetPage() {
      let self = this;
      window.clearInterval(this.interval);
      this.interval = setInterval(function() {
        self.getMainData();
      }, 20000);
    }
  },
  watch: {
    $route(to, from) {
      this.resetPage();
    }
  },
  created() {
    let self = this;
    this.reload();
    window.clearInterval(this.interval);
    this.interval = setInterval(function() {
      self.reload();
    }, 1000);
  },
  mounted: function() {
    this.resetPage();
    // this.getMainData();
  },
  beforeDestroy() {
    window.clearInterval(this.interval);
  }
};
</script>

<style lang="scss" scoped>
.child-canvas {
  position: relative;
  top: 0px;
  left: 0px;
  overflow: auto;
  height: 100%;
  .topo-wrap {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .to-container-btn {
      margin-top: 40px;
      margin-left: 40px;
      width: 106px;
      text-align: center;
      height: 26px;
      background: #389bc7;
      border-radius: 4px;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #ffffff;
      line-height: 26px;
      display: inline-block;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .click-btn {
    display: inline-block;
    &:hover {
      cursor: pointer;
    }
  }
}
// 小于1920的效果
@media only screen and (max-width: 1920px) {
  #myCanvas {
    transform: scale(0.8);
    margin-top: -80px;
    margin-left: -300px;
  }
}
// 大于1920的效果
@media only screen and (min-width: 1920px) {
  #myCanvas {
    transform: scale(1);
    margin-top: 0px;
    margin-left: 0px;
  }
}
</style>
<style>
.onpoint {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/childCanvas.vue